import { IPayerOnboardingMainViewModel, PayerOnboardingMainViewModel } from './main/payer-onboarding-main-view-model';
import { IPayerOnboardingAppState } from './payer-onboarding-app-state';
import { userActionChannel, Channel } from '../Shared/utils/user-action-channel';
import { PayerOnboardingUserAction } from './payer-onboarding-user-actions';
import * as Models from './payer-onboarding-generated';
import { defaultAppState } from './payer-onboarding-app-state';
import { HistoryAdapter } from '../WebGiving/utils/history-adapter';
import { createPayerOnboardingDataService, PayerOnboardingDataService } from './payer-onboarding-data-service';

export interface IPayerOnboardingSagaContext {
	readonly userActionChannel: Channel<PayerOnboardingUserAction>;
	readonly mainViewModel: IPayerOnboardingMainViewModel;
	readonly disableValidation?: boolean;
	readonly dataService: PayerOnboardingDataService;
	executingBlockingAction?: boolean;
	appState: IPayerOnboardingAppState;
}

export class PayerOnboardingSagaContext implements IPayerOnboardingSagaContext {
	readonly userActionChannel: Channel<PayerOnboardingUserAction>;
	readonly mainViewModel: IPayerOnboardingMainViewModel;
	appState: IPayerOnboardingAppState;

	executingBlockingAction?: boolean;

	public readonly dataService: PayerOnboardingDataService;

	constructor(viewData: Models.PayerOnboardingViewModel, disableValidation: boolean) {
		this.userActionChannel = userActionChannel();
		this.appState = defaultAppState();

		const history = new HistoryAdapter('pp-payeronboarding-key');
		history.start(() => this.executingBlockingAction);
		history.listen(() => {
			this.userActionChannel.put(new PayerOnboardingUserAction.PreviousPage());
		});

		this.dataService = createPayerOnboardingDataService(viewData.SessionCorrelationId);
		this.mainViewModel = new PayerOnboardingMainViewModel(viewData, this.userActionChannel, history, disableValidation);
	}
}


